import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FrownFilledSvg from "@ant-design/icons-svg/es/asn/FrownFilled";
import AntdIcon from "../components/AntdIcon";
var FrownFilled = function FrownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FrownFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FrownFilled.displayName = 'FrownFilled';
}
export default /*#__PURE__*/React.forwardRef(FrownFilled);